import { onMessageFromWebApp, sendMessageToWebApp, isBrowser } from "./webAppMessenger";
import { saveAs } from "file-saver";
import { DOWNLOAD, DOWNLOAD_ERROR, DOWNLOAD_SUCCESS } from "./messageTypes";
import { isDataURL, dataURLToBlob } from "../helpers/dataURL";

function getFileExtension(mimeType) {
  switch (mimeType) {
    case "image/jpeg":
      return ".jpg";
    case "image/png":
      return ".png";
    default:
      return "";
  }
}

async function downloadBlob(filename, blob) {
  if (isBrowser()) {
    saveAs(blob, filename);
  } else {
    const mimeType = blob.type;
    let storageLocation = "";

    switch (window.device.platform) {
      case "Android":
        storageLocation = window.cordova.file.externalDataDirectory;
        break;

      case "iOS":
        storageLocation = window.cordova.file.documentsDirectory;
        break;
    }

    const dir = await new Promise((resolve, reject) =>
      window.resolveLocalFileSystemURL(storageLocation, resolve, reject)
    );
    const file = await new Promise((resolve, reject) =>
      dir.getFile(`${filename}${getFileExtension(mimeType)}`, { create: true }, resolve, reject)
    );
    const fileWriter = await new Promise((resolve, reject) => file.createWriter(resolve, reject));
    const fileUrl = await new Promise((resolve, reject) => {
      fileWriter.onwriteend = () => resolve(file.toURL());
      fileWriter.onerror = reject;
      fileWriter.write(blob);
    });
    console.log("downloadBlob", fileUrl, blob, blob.type);
    await new Promise((resolve, reject) =>
      window.cordova.plugins.fileOpener2.open(fileUrl, mimeType, reject, resolve)
    );
    console.log("Successfully downloaded file!");
  }
}

onMessageFromWebApp(DOWNLOAD, async ({ url, fileName }) => {
  console.log(DOWNLOAD, fileName);
  try {
    let dataBlob;
    if (isDataURL(url)) {
      dataBlob = dataURLToBlob(url);
    } else {
      const response = await fetch(url);
      dataBlob = await response.blob();
    }
    downloadBlob(fileName, dataBlob);
    sendMessageToWebApp(DOWNLOAD_SUCCESS);
  } catch (error) {
    sendMessageToWebApp(DOWNLOAD_ERROR, { error });
    console.error(error);
  }
});
